/* ONH V15.18.3 — parity for public and non-Admin account scrolling.
   Native sticky left-first/right-second desktop handoff for all non-Admins.
   Restore the image position after tall portrait -> landscape for ALL accounts.
   Keep the original Elastislide, zoom and image-loading implementations. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('#productinfo.onh-pdp-v2');
    if (!root) return;
    var gallery = root.querySelector('#rg-gallery-main');
    var columns = root.querySelector('#product-columns-wrap');
    var left = root.querySelector('#product-left');
    var right = root.querySelector('#detail');
    if (!gallery || !columns || !left || !right) return;

    var admin = root.classList.contains('is-admin-customer');
    var desktop = window.matchMedia('(min-width: 1024px)');
    // One portrait-to-landscape return policy for guests, trade and Admin.
    function allowPortraitReturn() { return true; }
    var scheduled = false;
    var lastOrientation = null;
    var restore = null;
    var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
    var ro = typeof ResizeObserver === 'function' ? new ResizeObserver(requestMeasure) : null;

    // Legacy gallery keeps the preloaded hero until its first decoded image is ready.
    function image() {
      var live = gallery.querySelector('.rg-image > a > img:not(.prod-img-overlay)');
      if (live && live.complete && live.naturalWidth) return live;
      var fallback = gallery.querySelector('.rg-image-pre > img:not(.prod-img-overlay)');
      if (fallback && fallback.complete && fallback.naturalWidth) return fallback;
      return null;
    }
    function observe() {
      if (!ro || !observed) return;
      [gallery, left, right].forEach(function (el) {
        if (!observed.has(el)) { ro.observe(el); observed.add(el); }
      });
      var img = image();
      if (img && !observed.has(img)) { ro.observe(img); observed.add(img); }
    }
    function portrait(img) { return img.naturalHeight > img.naturalWidth * 1.12; }
    function titleScrollY() {
      return Math.max(0, Math.round(columns.getBoundingClientRect().top + window.scrollY - 20));
    }

    // When leaving a tall portrait, preserve its scroll runway while the page
    // travels back to the photograph/title. Otherwise the shorter landscape
    // replaces it mid-scroll and the browser clamps the page, causing a hop.
    function restoreTitle() {
      if (!allowPortraitReturn() || restore || !gallery.classList.contains('onh-v15-portrait-photo')) return;
      var target = titleScrollY();
      if (window.scrollY <= target + 5) return;
      restore = {target: target, started: performance.now()};
      window.scrollTo({top: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      window.requestAnimationFrame(checkRestore);
    }
    function checkRestore() {
      if (!restore) return;
      // Complete only when the title is back near its normal document position;
      // include a timeout in case a user interrupts the native smooth scroll.
      if (window.scrollY <= restore.target + 5 || performance.now() - restore.started > 1800 || !allowPortraitReturn()) {
        if (window.scrollY > restore.target + 5) window.scrollTo({top: restore.target, behavior: 'auto'});
        restore = null;
        requestMeasure();
      } else {
        window.requestAnimationFrame(checkRestore);
      }
    }
    function targetThumb(event) {
      var node = event.target;
      if (!node || !node.closest) return null;
      var li = node.closest('.rg-thumbs li');
      if (li && gallery.contains(li)) return li.querySelector('img');
      var nav = node.closest('.rg-image-nav-prev, .rg-image-nav-next');
      if (!nav || !gallery.contains(nav)) return null;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.rg-thumbs li img'));
      if (!thumbs.length) return null;
      var current = thumbs.findIndex(function (img) { return !!img.closest('li.selected'); });
      if (current < 0) current = 0;
      var step = nav.classList.contains('rg-image-nav-next') ? 1 : -1;
      return thumbs[(current + step + thumbs.length) % thumbs.length];
    }
    // Capture precedes the legacy gallery click handler, so a landscape can
    // initiate restoration BEFORE its shorter full-size photo is swapped in.
    gallery.addEventListener('click', function (event) {
      if (!gallery.classList.contains('onh-v15-portrait-photo')) return;
      var thumb = targetThumb(event);
      if (!thumb) return;
      var selectedAspect = parseFloat(thumb.getAttribute('data-onh-original-aspect'));
      if ((selectedAspect > 0 && selectedAspect >= 1 / 1.12) ||
          (!(selectedAspect > 0) && thumb.complete && thumb.naturalWidth && !portrait(thumb))) {
        restoreTitle();
      }
    }, true);

    // The legacy touch-swipe handler bypasses thumbnail clicks. Apply the same
    // photo-return behavior on touch for every customer/account state.
    // Never cancel the actual swipe gesture.
    {
      var onhTouchStart = null;
      gallery.addEventListener('touchstart', function (event) {
        if (!gallery.classList.contains('onh-v15-portrait-photo') || !event.touches.length) return;
        onhTouchStart = {x: event.touches[0].clientX, y: event.touches[0].clientY};
      }, {passive: true, capture: true});
      gallery.addEventListener('touchend', function (event) {
        if (!onhTouchStart || !event.changedTouches.length) return;
        var dx = event.changedTouches[0].clientX - onhTouchStart.x;
        var dy = event.changedTouches[0].clientY - onhTouchStart.y;
        onhTouchStart = null;
        if (Math.abs(dx) <= 35 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.rg-thumbs li img'));
        if (!thumbs.length) return;
        var current = thumbs.findIndex(function (img) { return !!img.closest('li.selected'); });
        if (current < 0) current = 0;
        var next = thumbs[(current + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
        var aspect = next && parseFloat(next.getAttribute('data-onh-original-aspect'));
        if (aspect > 0 && aspect >= 1 / 1.12) restoreTitle();
      }, {passive: true, capture: true});
    }

    function update() {
      scheduled = false;
      observe();
      var img = image();
      if (!img) return;
      var isPortrait = portrait(img);
      // Also catches keyboard/swipe and thumbnails not yet loaded at click.
      if (allowPortraitReturn() && lastOrientation === true && !isPortrait && !restore) {
        restoreTitle();
      }
      lastOrientation = isPortrait;
      // Hold the previous sticky geometry until native scrolling completes.
      if (restore) return;
      gallery.classList.toggle('onh-v15-portrait-photo', isPortrait);

      // Old V15.10 inline transforms are deliberately retired. The browser
      // provides native subpixel sticky scrolling, including trackpads/touch.
      right.style.removeProperty('transform');
      right.style.removeProperty('will-change');
      // Tablet/mobile is stacked by the original theme; Admin intentionally
      // retains its existing desktop flow. Desktop public and all trade tiers
      // share the identical left-first/right-second handoff.
      if (admin || !desktop.matches) {
        root.classList.remove('onh-v1511-sticky-details');
        gallery.classList.remove('onh-v1513-tall-portrait');
        gallery.style.removeProperty('--onh-v1513-thumbs-height');
        left.style.removeProperty('--onh-guest-sticky-top');
        columns.style.removeProperty('min-height');
        return;
      }
      // Only unusually tall non-Admin portraits get the 20px INSIDE-the-photo
      // carousel landing. Short portraits and landscapes keep V15.12 layout.
      // Measure the existing original strip, never clone or replace it.
      var thumbs = gallery.querySelector(':scope > .rg-thumbs');
      var photoHeight = img.getBoundingClientRect().height;
      var thumbsHeight = thumbs && window.getComputedStyle(thumbs).display !== 'none'
        ? thumbs.getBoundingClientRect().height : 0;
      var longPortrait = isPortrait && thumbsHeight > 0 &&
        photoHeight > window.innerHeight + 100;
      if (longPortrait) {
        gallery.style.setProperty('--onh-v1513-thumbs-height', Math.ceil(thumbsHeight) + 'px');
      } else {
        gallery.style.removeProperty('--onh-v1513-thumbs-height');
      }
      gallery.classList.toggle('onh-v1513-tall-portrait', longPortrait);

      // Handoff depends on the WHOLE left lane, not just the photograph.
      // Any swatches, labels or public-side widgets below the carousel finish
      // passing just above the viewport BEFORE the right text begins moving.
      var leftHeight = left.getBoundingClientRect().height;
      if (!(leftHeight > 0)) return;
      var stickyTop = Math.min(20, window.innerHeight - leftHeight - 16);
      left.style.setProperty('--onh-guest-sticky-top', Math.round(stickyTop) + 'px');

      // Right stays pinned at 20px until the full left rail's last widget
      // reaches 16px from the viewport bottom. Native sticky handles the
      // subpixel transition; no scroll/resize-per-frame element transforms.
      var travel = isPortrait ? Math.max(0, Math.ceil(leftHeight - window.innerHeight + 36)) : 0;
      var useHandoff = travel > 0;
      root.classList.toggle('onh-v1511-sticky-details', useHandoff);
      var requiredHeight = useHandoff ? Math.ceil(right.offsetHeight + travel) : 0;
      var oldHeight = parseFloat(columns.style.minHeight) || 0;
      if (Math.abs(oldHeight - requiredHeight) > 1) {
        if (requiredHeight) columns.style.minHeight = requiredHeight + 'px';
        else columns.style.removeProperty('min-height');
      }
    }
    function requestMeasure() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    }
    gallery.addEventListener('load', requestMeasure, true);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () { observe(); requestMeasure(); }).observe(gallery, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class']
      });
    }
    window.addEventListener('resize', requestMeasure, {passive:true});
    observe();
    requestMeasure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
